import classNames from 'classnames'
import StyledLoader from 'components/Elements/StyledLoader'
import GuideButtons from 'sections/Dashboard/features/SetupGuide/components/GuideButtons'
import { DataContext } from 'contexts/DataContextContainer'
import { useContext } from 'react'
import { Button, Col, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useLocaleTagsQuery } from 'store/queries'

function AddPrompts({
  onSave,
  onPrevious,
  selectedTagIds,
  toggleTag,
  isLoadingBookTags,
}) {
  const { t } = useTranslation()
  const { lang } = useContext(DataContext)
  const { isSuccess, data: tags } = useLocaleTagsQuery(lang)

  if (!isSuccess || isLoadingBookTags) return <StyledLoader />

  return (
    <div className="card-body-container card-body-story-container">
      <div className="card card-body">
        <div className="progressbar-container">
          <div className="text-left mt-3">
            <h4>{t('book_setup_guide_five_title')}</h4>
          </div>

          <div className="text-left prompts-container">
            <Row className="mb-3">
              {tags?.map((tag) => (
                <Col md={{ span: 4 }} key={tag.id}>
                  <Button
                    className={classNames('btn-story mt-3', {
                      active: selectedTagIds[tag.id],
                    })}
                    onClick={() => toggleTag(tag.id)}
                  >
                    {tag.name}
                  </Button>
                </Col>
              ))}
            </Row>
          </div>
        </div>
      </div>

      <GuideButtons onSave={onSave} onPrevious={onPrevious} />
    </div>
  )
}

export default AddPrompts
